module.exports = __webpack_public_path__ + "img/face-confounded.446017ae.svg";